import { EstimatedTransitTime, QuoteStage, QuoteStatus, ServiceType } from '@pelicargo/types';
import { ShipmentStatus } from '@prisma/client';

export type options = Record<string, string>;

export const MULTI_KEY = '[Multi]' as const;

export const QuotesStatusesToBeValidated: QuoteStatus[] = [QuoteStatus.ReadyForQC, QuoteStatus.InProgress];

export const QUOTE_BOOKABLE_STAGES = [QuoteStage.TWO, QuoteStage.THREE, QuoteStage.FOUR];

export const SEGMENTS_TO_ETT = {
  0: EstimatedTransitTime.TwoToThreeDays,
  1: EstimatedTransitTime.TwoToThreeDays,
  2: EstimatedTransitTime.ThreeToFourDays,
  3: EstimatedTransitTime.FourToFiveDays,
  4: EstimatedTransitTime.FiveToSixDays,
  5: EstimatedTransitTime.SevenDaysPlus,
} as const;

export const COMMON_WEIGHT_BREAKS = [45, 100, 150, 250, 300, 500, 1000, 3000, 5000];
export const inCommonWeightBreak = (n: number) =>
  COMMON_WEIGHT_BREAKS.reduce(
    (agg, wb, i) => {
      if (wb < n) {
        agg.min = wb;
        agg.max = COMMON_WEIGHT_BREAKS?.[i + 1] ?? undefined;
      }
      return agg;
    },
    { min: 0, max: 45 },
  );

export const ServiceTypePriority = [
  ServiceType.Other,
  ServiceType.General,
  ServiceType.Expedited,
  ServiceType.Urgent,
] as const satisfies ServiceType[];

export const FPAllowedShipmentStatuses = [
  ShipmentStatus.PICKUP_SCHEDULED,
  ShipmentStatus.PICKUP_COMPLETE,
  ShipmentStatus.AT_WAREHOUSE,
  ShipmentStatus.OUT_FOR_DELIVERY,
  ShipmentStatus.AIRLINE_ACCEPTED,
  ShipmentStatus.ON_HOLD,
] as const satisfies ShipmentStatus[];
